"use client";

import React, { useState } from "react";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import { cn } from "utils";
import { InsightPanel } from "../InsightPanel";
import { InsightModalProps } from "./types";
import { OtherAsset } from "./otherAsset";
import Translations from "@translate/components/Portfolio/AssetInsight/InsightModal/InsightModal";
import { I18nUtil } from "@utils/i18n";
import { EdgenModalCreateAble } from "@/src/components/EdgenModal";

const I18n = I18nUtil.createScoped(Translations);

/**
 * @description 统一的资产洞察弹窗骨架，支持根据 viewName 展示不同内容。
 */
const InsightModal: React.FC<InsightModalProps> = ({
  onClose,
  viewName = "summary",
  accountId,
  data,
  topAssets,
  assetTypes,
  value,
  isExternal,
}) => {
  const [screenName, setScreenName] = useState(viewName);
  return (
    <div
      className={cn(
        "h-[calc(100vh-120px)] md:h-fit md:max-h-[calc(100vh-160px)]",
        {
          "overflow-y-hidden": screenName === "all",
        },
      )}
    >
      <div className="h-[calc(100vh-120px)] md:h-fit md:max-h-[calc(100vh-160px)] flex flex-col">
        <header
          aria-label="Insight Modal header"
          data-openreplay-label="Insight Modal header Semantic"
          id="sem-insight-modal-header"
          className="p-4 flex flex-row rounded-t-4 justify-between sticky top-0 z-10 bg-background_solid_secondary"
        >
          <div className="flex gap-2 flex-row">
            <button
              data-openreplay-label="back Button"
              id="btn-back-insightmodal-insightmodal"
              onClick={() => setScreenName("summary")}
              className={cn("w-6 h-6 xl:hidden", {
                hidden: screenName === "summary",
              })}
              aria-label="back"
            >
              <Icon
                name="left-arrow-alt"
                size={24}
                className="text-content_primary"
              />
            </button>
            <span className="headline_regular_s text-content_primary">
              {screenName === "summary"
                ? I18n.t("Chart")
                : I18n.t("Other Assets")}
            </span>
          </div>
          <button
            data-openreplay-label="Close Button"
            id="btn-close-insightmodal-insightmodal-3"
            onClick={onClose}
            className="w-5 h-5 rounded-full flex items-center justify-center transition-colors"
            aria-label="Close"
          >
            <Icon
              name="close"
              size={20}
              className="text-content_tertiary hover:text-content_secondary"
            />
          </button>
        </header>
        <div
          className={cn("px-4 pb-3 md:pb-6 flex-1", {
            "overflow-y-hidden": screenName === "all",
          })}
        >
          <InsightPanel
            onViewAll={() => setScreenName("all")}
            className={cn({ hidden: screenName === "all" })}
            accountId={accountId}
            data={data}
            topAssets={topAssets}
            assetTypes={assetTypes}
            value={value}
            isExternal={isExternal}
          />
          <OtherAsset
            className={cn({ hidden: screenName === "summary" })}
            topAssets={topAssets}
          />
        </div>
      </div>
    </div>
  );
};

export const openInsightModal = async (props: InsightModalProps) => {
  const { onClose, ...otherProps } = props;
  // return new Promise((resolve) => {
  await EdgenModalCreateAble.call({
    children: (
      <InsightModal
        onClose={() => {
          EdgenModalCreateAble.end(false);
          onClose();
        }}
        {...otherProps}
      />
    ),
    containerClassName: "!md:w-[400px] !md:rounded-2xl",
    className: "[--modal-radius:16px_16px_0_0] md:[--modal-radius:16px]",
    contentStyle: {
      borderRadius: "var(--modal-radius)",
      backgroundColor: ospThemes.colors.background_solid_secondary,
      width: "100%",
      padding: 0,
    },
    titleStyle: {
      minHeight: 0,
    },
    showClose: false,
    destroyOnClose: true,
  });
  onClose();
  // })
};
